<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » ユーザー入力タイトルダイアログの説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>ユーザー入力タイトルダイアログの説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/user-input-title-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、選択した内容は反映されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 全言語自動翻訳
        </div>
        <div class="manual-explain">
          全言語の自動翻訳チェックボックスに対して、ON/OFFを切り替えます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> ユーザー入力タイトル（メイン言語）
        </div>
        <div class="manual-explain">
          ユーザー入力タイトルを設定します。<br>
          ユーザー予約時の「備考欄」入力フォームの項目名として利用します。<br>
          <a [href]="projectDialogLink">プロジェクト情報：編集画面</a>で設定された言語の１番目のものがメイン言語となります。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> ユーザー入力タイトル（翻訳用）
        </div>
        <div class="manual-explain">
          自動翻訳用のユーザー入力タイトルを設定します。<br>
          ここで設定された内容をもとに各言語の翻訳を行います。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> ユーザー入力タイトル（他言語）
        </div>
        <div class="manual-explain">
          ユーザー入力タイトルを設定します。<br>
          自動翻訳にチェックを入れることで翻訳処理が実行されます。（設定内容は翻訳処理によって上書きされます）
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集した内容を反映します。
        </div>

      </mat-card-content>
    </mat-card>
  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">Usage Top</a> » Description of the User Input Title Dialog
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Description of the User Input Title Dialog</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_user-input-title-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Click to close the dialog.<br>
          Any changes made will not be saved.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Auto-Translate All Languages
        </div>
        <div class="manual-explain">
          Toggle the auto-translate checkbox for all languages ON/OFF.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> User Input Title (Main Language)
        </div>
        <div class="manual-explain">
          Set the user input title.<br>
          This will be used as the name of the input field in the "Remarks" section during user reservations.<br>
          The first language set in the <a [href]="projectDialogLink">Project Information: Edit Screen</a> will be the
          main language.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> User Input Title (For Translation)
        </div>
        <div class="manual-explain">
          Set the user input title for automatic translation.<br>
          The content set here will be used as the basis for translations into other languages.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> User Input Title (Other Languages)
        </div>
        <div class="manual-explain">
          Set the user input title for other languages.<br>
          If auto-translate is enabled, the content will be translated (overwriting the set content).
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> Update Button
        </div>
        <div class="manual-explain">
          Click to save the changes made.
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>